import NotificationPage from './NotificationPage'
import { notificationMenu } from './sideBarOption'

export { notificationMenu }
export default NotificationPage
